import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Input from '../input'
import {emitOnBlur} from '@cred/react-analytics/hoc'
import {InputComponent} from './inputComponent'

const inputComponentWithAnalytics = /*#__PURE__*/ emitOnBlur(InputComponent)

export const defaultIsAllowed = floatValue => floatValue === undefined || floatValue <= 100

/**
 * @visibleName APR Input
 */
class AprInput extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    small: PropTypes.bool,
    id: PropTypes.string,
    isManualTrade: PropTypes.bool,
    placeholder: PropTypes.string,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ]),
    className: PropTypes.string,
    forceOpenTooltip: PropTypes.bool,
    type: PropTypes.oneOf(['text', 'tel']),
	  analyticsContexts: PropTypes.array,
    isAllowed: PropTypes.func
  }

  static defaultProps = {
    id: '',
    name: '',
    placeholder: '',
    isManualTrade: false,
    className: '',
    label: '',
    small: false,
    validate: () => {},
    forceOpenTooltip: false,
	  type: 'text',
	  analyticsContexts: [],
    isAllowed: defaultIsAllowed
  }

  render() {
    const {
      className,
      name,
      label,
      validate,
      placeholder,
      small,
      forceOpenTooltip,
	    type,
      ...props
    } = this.props

    return (
      <div className={className}>
        <Input
          type={type}
          name={`${name}`}
          label={label}
          small={small}
          forceOpenTooltip={forceOpenTooltip}
          component={inputComponentWithAnalytics}
          validate={validate}
          placeholder={placeholder}
          {...props}
        />
      </div>
    )
  }
}

export {AprInput}

export default AprInput
